<template>
  <span>
    <div id="start_overlay">
        <span id="loading_section" v-show="$store.getters['app/loading']">
            <h1 id="loading_text">Aan het laden...
              <br>
              <span v-show="$store.getters['app/percentageLoad'] != null" v-html="$store.getters['app/percentageLoad']"></span>
            </h1>
        </span>

        <!-- App -->
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 74.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 75.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 49.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 72.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 83.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 111.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 128.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 107.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 130.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 112.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 76.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 109.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 102.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 1.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 129.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 113.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 82.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 81.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 100.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 126.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/49.jpeg">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 77.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 78.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 79.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 108.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 80.png">

        <img class="loaders" @load="addLoader()" src="./../assets/images/persons/83.jpeg">
        <img class="loaders" @load="addLoader()" src="./../assets/images/persons/76.jpeg">
        <img class="loaders" @load="addLoader()" src="./../assets/images/persons/77.jpeg">
        <img class="loaders" @load="addLoader()" src="./../assets/images/persons/78.jpeg">
        <img class="loaders" @load="addLoader()" src="./../assets/images/persons/79.jpeg">
        <img class="loaders" @load="addLoader()" src="./../assets/images/persons/82.jpeg">
        <img class="loaders" @load="addLoader()" src="./../assets/images/persons/107.jpeg">
        <img class="loaders" @load="addLoader()" src="./../assets/images/persons/49.jpeg">
        <img class="loaders" @load="addLoader()" src="./../assets/images/persons/100.jpeg">
        <img class="loaders" @load="addLoader()" src="./../assets/images/persons/112.jpeg">
        <img class="loaders" @load="addLoader()" src="./../assets/images/persons/1.jpeg">
        <img class="loaders" @load="addLoader()" src="./../assets/images/persons/113.jpeg">
        <img class="loaders" @load="addLoader()" src="./../assets/images/persons/129.jpeg">
        <img class="loaders" @load="addLoader()" src="./../assets/images/persons/130.jpeg">
        <img class="loaders" @load="addLoader()" src="./../assets/images/persons/126.jpeg">
        <img class="loaders" @load="addLoader()" src="./../assets/images/persons/111.jpeg">

    </div>
  </span>
</template>

<script>


export default {
  name: "Preload",

  data() {
    return {
      loader: 0
    };
  },

  methods: {
    addLoader() {
      this.loader++;
    }
  },

  watch: {
    loader(loaded) {
      /**
       * Be sure that this is the exact amount of assets to be loaded
       */
      const total_elements = document.getElementsByClassName('loaders').length;

      this.$store.dispatch('app/asyncUpdatePercentageLoad', {
          percentage_load: parseInt( ( loaded / total_elements ) * 100 ) + ' / 100',
      });

      // If critical assets are loaded, show start button
      if ( loaded == total_elements ) {
        this.$store.dispatch('app/asyncUpdateStarted', {
          started: true,
        });
        this.$store.dispatch('app/asyncUpdateLoading', {
          loading: false,
        });
        this.$router.push('/');

        this.$store.dispatch('app/asyncUpdatePercentageLoad', {
          percentage_load: null,
        });
      }
    }
  },
};
</script>

<style>
  #start_overlay {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-color: #b08f6c;
  }

  .loaders {
    display: none;
  }

  #loading_text {
    font-family: 'LuckiestGuy';
    margin-top: 8%;
    width: 100%;
    height: 20%;
    left: 0%;
    color: white;
    font-size: 5vw;
    text-align: center;
    font-size: 4em;
    color: white;
    z-index: 100;
  }

  #loading_section {
    z-index: 100;
    position: fixed;
    width: 100%;
  }
</style>
